import script from "./ForInvestors.vue?vue&type=script&setup=true&lang=js"
export * from "./ForInvestors.vue?vue&type=script&setup=true&lang=js"

import "./ForInvestors.vue?vue&type=style&index=0&id=29a8da83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29a8da83"]])

export default __exports__